// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "./CSS.bs.js";
import * as DataAttribute$Showside from "./DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "./ReactDOMUtils.bs.js";
var importModule = function importHls() {
  return import("hls.js");
};
var isSupported = function isSupported(hlsModule) {
  return hlsModule.default ? hlsModule.default.isSupported() : hlsModule.isSupported();
};
var newHls = function newHls(hlsModule, config) {
  return hlsModule.default ? new hlsModule.default(config) : new hlsModule(config);
};
var getEvent = function getManifesetParsedEvent(hlsModule, eventName) {
  return (hlsModule.default ? hlsModule.default : hlsModule).Events[eventName];
};
function isHls(src) {
  return src.includes(".m3u8");
}
function isCloudflare(src) {
  return src.includes("cloudflarestream");
}
function init(element, src) {
  return Curry._1(importModule, undefined).then(function (hlsModule) {
    var match = isSupported(hlsModule);
    if (match) {
      var hls = newHls(hlsModule, {
        startLevel: undefined,
        minAutoBitrate: 2500000,
        lowLatencyMode: undefined
      });
      hls.loadSource(src);
      hls.attachMedia(element);
      return Caml_option.some(hls);
    }
    if (!element.canPlayType("application/vnd.apple.mpegurl")) {
      return;
    }
    var src$1 = src.includes("cloudflarestream") ? src + "?clientBandwidthHint=4#t=0.01" : src;
    element.src = src$1;
  });
}
var Hls = {
  importModule: importModule,
  isSupported: isSupported,
  newHls: newHls,
  getEvent: getEvent,
  isHls: isHls,
  isCloudflare: isCloudflare,
  init: init
};
function Video(Props) {
  var alt = Props.alt;
  var src = Props.src;
  var autoPlayOpt = Props.autoPlay;
  var controlsOpt = Props.controls;
  var loopOpt = Props.loop;
  var mutedOpt = Props.muted;
  var poster = Props.poster;
  var width = Props.width;
  var height = Props.height;
  var preloadOpt = Props.preload;
  var videoRef = Props.videoRef;
  var onCanPlay = Props.onCanPlay;
  var onPlay = Props.onPlay;
  var onPause = Props.onPause;
  var onEnded = Props.onEnded;
  var onError = Props.onError;
  var onLoad = Props.onLoad;
  var onLoadedMetadata = Props.onLoadedMetadata;
  var objectFitOpt = Props.objectFit;
  var positionOpt = Props.position;
  var cssPrefixOpt = Props.cssPrefix;
  var onTimeChange = Props.onTimeChange;
  var initialTime = Props.initialTime;
  var dataTestId = Props.dataTestId;
  var dataId = Props.dataId;
  var disabledOpt = Props.disabled;
  var classNameOpt = Props.className;
  var autoPlay = autoPlayOpt !== undefined ? autoPlayOpt : false;
  var controls = controlsOpt !== undefined ? controlsOpt : true;
  var loop = loopOpt !== undefined ? loopOpt : false;
  var muted = mutedOpt !== undefined ? mutedOpt : false;
  var preload = preloadOpt !== undefined ? preloadOpt : "auto";
  var objectFit = objectFitOpt !== undefined ? objectFitOpt : "cover";
  var position = positionOpt !== undefined ? positionOpt : "relative";
  var cssPrefix = cssPrefixOpt !== undefined ? cssPrefixOpt : CSS$Showside.prefix;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var elementRef = React.useRef(null);
  var hlsRef = React.useRef(undefined);
  var videoRef$1 = videoRef !== undefined ? videoRef : elementRef;
  var isHls$1 = Belt_Option.mapWithDefault(src, false, isHls);
  var appliedSrc = isHls$1 ? undefined : src;
  React.useEffect(function () {
    var match = videoRef$1.current;
    if (!(match == null) && isHls$1 && src !== undefined && !disabled) {
      init(match, src).then(function (hls) {
        hlsRef.current = hls;
      });
    }
    return function (param) {
      var hls = hlsRef.current;
      if (hls === undefined) {
        return;
      }
      var hls$1 = Caml_option.valFromOption(hls);
      hls$1.detachMedia();
      hls$1.destroy();
    };
  }, [isHls$1, disabled]);
  React.useEffect(function () {
    var element = videoRef$1.current;
    if (!(element == null)) {
      element.defaultMuted = muted;
      element.muted = muted;
    }
  }, [muted]);
  React.useEffect(function () {
    var handleTimeUpdate = function (param) {
      if (onTimeChange === undefined) {
        return;
      }
      var time = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(videoRef$1.current), 0, function (prim) {
        return prim.currentTime;
      });
      var duration = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(videoRef$1.current), 0, function (prim) {
        return prim.duration;
      });
      Curry._2(onTimeChange, time, duration);
    };
    var element = videoRef$1.current;
    if (!(element == null)) {
      element.addEventListener("timeupdate", handleTimeUpdate);
    }
    return function (param) {
      var element = videoRef$1.current;
      if (!(element == null)) {
        element.removeEventListener("timeupdate", handleTimeUpdate);
        return;
      }
    };
  }, []);
  React.useEffect(function () {
    var match = videoRef$1.current;
    if (!(match == null) && initialTime !== undefined) {
      match.currentTime = initialTime;
    }
  }, []);
  var tmp = {
    ref: ReactDOMUtils$Showside.Ref.domRef(videoRef$1),
    className: Cn.make([objectFit === "contain" ? Curry._1(cssPrefix, "object-contain") : objectFit === "scale-down" ? Curry._1(cssPrefix, "object-scale-down") : Curry._1(cssPrefix, "object-cover"), Curry._1(cssPrefix, "w-full h-full min-w-full min-h-full"), position === "relative" ? "" : Curry._1(cssPrefix, "absolute inset-0"), className]),
    autoPlay: autoPlay,
    controls: controls,
    loop: loop,
    muted: muted,
    playsInline: true,
    preload: preload
  };
  if (alt !== undefined) {
    tmp.alt = Caml_option.valFromOption(alt);
  }
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (poster !== undefined) {
    tmp.poster = Caml_option.valFromOption(poster);
  }
  if (appliedSrc !== undefined) {
    tmp.src = Caml_option.valFromOption(appliedSrc);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  if (onCanPlay !== undefined) {
    tmp.onCanPlay = Caml_option.valFromOption(onCanPlay);
  }
  if (onEnded !== undefined) {
    tmp.onEnded = Caml_option.valFromOption(onEnded);
  }
  if (onError !== undefined) {
    tmp.onError = Caml_option.valFromOption(onError);
  }
  if (onLoadedMetadata !== undefined) {
    tmp.onLoadedMetadata = Caml_option.valFromOption(onLoadedMetadata);
  }
  if (onPause !== undefined) {
    tmp.onPause = Caml_option.valFromOption(onPause);
  }
  if (onPlay !== undefined) {
    tmp.onPlay = Caml_option.valFromOption(onPlay);
  }
  if (onLoad !== undefined) {
    tmp.onLoad = Caml_option.valFromOption(onLoad);
  }
  var tmp$1 = {
    dataOriginalSrc: src,
    dataVideoMuted: muted,
    dataVideoLoop: loop,
    children: React.createElement("video", tmp),
    disablePictureInPicture: true
  };
  if (dataTestId !== undefined) {
    tmp$1.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataId !== undefined) {
    tmp$1.dataId = dataId;
  }
  return React.createElement(DataAttribute$Showside.make, tmp$1);
}
Video.displayName = "Video";
var make = Video;
export { Hls, make };
/* react Not a pure module */